import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { RadioComponent } from '@valk-nx/components/ui-radio/src/lib/radio';
import { cn } from '@valk-nx/core/lib/core';

import type { FiltersItemInterface } from '../../contracts/filters.interface';
import { collapsibleItems } from '../collapsible-items';
import { withAvailability } from '../filter-item-availability';
import { uniqueGroupName } from '../unique-group-name';

@Component({
	selector: `vp-filter-radio-group`,
	templateUrl: './filter-radio-group.html',
	host: { class: 'contents' },
	imports: [RadioComponent, TranslatePipe],
})
export class FilterRadioGroupComponent {
	title = input.required<string>();
	items = input<FiltersItemInterface[]>([]);
	itemsLimit = input.required<number>();
	activeValue = input<string>('');

	changed = output<string>();

	protected readonly collapsible = collapsibleItems(
		this.items,
		this.itemsLimit,
	);

	protected readonly groupName = uniqueGroupName(this.title);

	protected readonly cn = cn;

	protected readonly options = computed(() =>
		withAvailability(this.collapsible.visibleItems(), [this.activeValue()]),
	);

	onSelect(value: string): void {
		if (value !== this.activeValue()) {
			this.changed.emit(value);
		}
	}
}
